import React from "react";
import { DistributionBiller } from "../modules/DistributionsBiller";

export function DistributionsBillerPage() {
  return <DistributionBiller />;
}
